import React, { useState, useEffect } from "react"
import { sortData, paginateData } from "../../utils/common"
import { get } from "../../utils/apiClient"
import moment from "moment-timezone"
import Pagination from "../common/pagination"

function History({ selectedFax, faxNumberToDisplay, authUser }) {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [sortConfig] = useState({
    key: "createdDatetime",
    direction: "desc",
  })

  const fetchHistory = async () => {
    try {
      const data = await get(`/fax/auditLogs?faxId=${selectedFax.fax_id}`)
      setHistory(data)
    } catch (error) {
      console.error("Failed to fetch history", error)
      setHistory([])
    }
  }

  const loadHistory = async () => {
    setLoading(true)
    await fetchHistory()
    setLoading(false)
  }

  const handleExportCsv = () => {
    const headers = ["Fax Number", "Action", "Time", "Username"]
    const rows = history.map((h) => [
      h.faxNumber,
      h.faxAction,
      moment.unix(h?.createdDatetime).tz("America/New_York").format("MM/DD/YYYY hh:mm A"),
      h.userName,
    ])
    const csvContent = [headers, ...rows]
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","))
      .join("\n")
    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${faxNumberToDisplay}_history.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  useEffect(() => {
    loadHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFax.fax_id])

  const sortedHistory = sortData(history, sortConfig)
  const currentHistory = paginateData(sortedHistory, currentPage, rowsPerPage)
  const totalPages = Math.ceil(history.length / rowsPerPage)

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden" }}>
      {loading ? (
        <div className="loading-container">
          <div className="loading-pdf-message">Loading ...</div>
        </div>
      ) : (
        <>
          <div className="table-container" style={{ overflowX: "auto", overflowY: "auto" }}>
            <table className="faxes-table" style={{ marginTop: "5px" }}>
              <thead>
                <tr>
                  <th className="faxes-th">Action</th>
                  <th className="faxes-th">Time</th>
                  <th className="faxes-th">Email</th>
                </tr>
              </thead>
              <tbody>
                {currentHistory.length > 0 ? (
                  currentHistory?.map((h) => (
                    <tr key={h.faxNumber} className="fax-item" style={{ cursor: "unset" }}>
                      <td className="faxes-td">{h?.faxAction}</td>
                      <td className="faxes-td">
                        {moment.unix(h?.createdDatetime).tz("America/New_York").format("MM/DD/YYYY hh:mm A")}
                      </td>
                      <td className="faxes-td">{h?.userName}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center", padding: "10px", border: "1px solid #ccc" }}>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="faxes-pagination" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
            {(authUser.userRole === "SUPER_ADMIN" || authUser.userRole === "ADMIN") ? (
              <button className="faxes-button" onClick={handleExportCsv} style={{ marginLeft: "0px" }}>
                Export to CSV
              </button>
            ) : <div />}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              totalRows={history.length}
              onPageChange={(page) => setCurrentPage(page)}
              onRowsPerPageChange={(count) => {
                setRowsPerPage(count)
                setCurrentPage(1)
              }}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default History
